import React from 'react';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helpText?: string;
}

/**
 * Checkbox component with optional label
 */
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, helpText, className, id, ...props }, ref) => {
    const inputId = id || `checkbox-${Math.random().toString(36).slice(2)}`;

    return (
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            ref={ref}
            id={inputId}
            type="checkbox"
            className={`
              w-4 h-4
              rounded border-gray-300 dark:border-gray-600
              text-indigo-600 dark:text-indigo-500
              focus:ring-indigo-500 dark:focus:ring-indigo-400
              focus:ring-2
              cursor-pointer
              transition-colors duration-200
              ${className || ''}
            `}
            {...props}
          />
        </div>
        {label && (
          <div className="ms-3 text-sm">
            <label htmlFor={inputId} className="font-medium text-gray-900 dark:text-gray-100 cursor-pointer">
              {label}
            </label>
            {helpText && <p className="text-gray-500 dark:text-gray-400">{helpText}</p>}
          </div>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
